module.exports = __webpack_public_path__ + "static/media/youtube-round.56cd4ab1.svg";